import { ThemeSpaceKeys } from '@agria/theme/src/styles/tokens/space';

export type ImageTokens = {
  borderRadius: ThemeSpaceKeys;
};

export const tokens: ImageTokens = {
  borderRadius: 'xxxSmall',
} as const;

export default tokens;
